var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16663 13.5417V21.5312C2.16663 22.2016 2.70829 22.75 3.37033 22.75H4.57403C5.23607 22.75 5.77774 22.2016 5.77774 21.5312V20.3125H20.2222V21.5312C20.2222 22.2016 20.7639 22.75 21.4259 22.75H22.6296C23.2916 22.75 23.8333 22.2016 23.8333 21.5312V11.7812L21.3296 4.48094C21.0889 3.76188 20.4148 3.25 19.6203 3.25H9.74996V5.6875H19.187L20.4389 9.34375H9.74996V13.5417C9.74996 14.1613 9.60133 14.7462 9.33778 15.2627C9.11998 15.6895 8.83256 16.0916 8.34878 16.485C7.69651 17.0154 6.86453 17.3333 5.95829 17.3333C3.86421 17.3333 2.16663 15.6357 2.16663 13.5417ZM16.6111 14.8281C16.6111 15.8397 17.4176 16.6563 18.4166 16.6563C19.4157 16.6563 20.2222 15.8397 20.2222 14.8281C20.2222 13.8166 19.4157 13 18.4166 13C17.4176 13 16.6111 13.8166 16.6111 14.8281Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.33329 16.25L4.33329 6.39168H2.16663L5.41663 1.08334L8.66663 6.39168L6.49996 6.39168L6.49996 16.25H4.33329Z",
    fill: "inherit"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarExit);
export default __webpack_public_path__ + "static/media/car-exit.19b7fd0775be24badc85895ce7f5be59.svg";
export { ForwardRef as ReactComponent };